import requests from "./request";
// 类型

// http://erptest.ohdt.top/prod-api/system/dict/data/type/plan_type
export const selestType = (data) => {
  return requests({ url: "/system/dict/data/type/" + data, method: "get" });
};

//提交需求
export const onyhUserDemand = (data) => {
  return requests({ url: "/erp/onyhUserDemand", method: "post", data });
};




// WEBPACK FOOTER //
// ./src/request/api.js